export default {
  titles: {
    page: 'Récapitulatif',
    loading: 'Chargement',
    delivery: 'Livraison',
  },
  usefulInfo: 'Information pratiques',
  address: 'Adresse',
  date: 'Date',
  access: 'Accès',
  unknownAccess: 'A déterminer',
  unknownAddress: 'A préciser',
  lift: 'Ascenseur',
  vlAccess: 'Accès camion',
  vl: {
    access: 'Accès camion',
    canPark: 'aucune difficulté - tout type de camion',
    cannotPark: 'véhicule léger uniquement (VL max 3T5)',
  },
  floor: 'Étage',
  serviceOffer: 'Prestations',
  estimationPrice: 'Prix estimé de votre déménagement',
  estimationText: 'Après validation de votre formulaire par notre expert '
    + 'et mise en concurrence de notre réseau local et national de déménageurs, '
    + '<b>vous recevrez notre sélection des 3 à 6 meilleures offres</b> pour votre '
    + 'déménagement via notre <b>comparateur de déménageurs en ligne</b>.',
  estimationCancelText: 'Votre demande a bien été annulée, mais vous pouvez toujours la confirmer si vous le souhaitez.'
    + '<br><br>Après validation de votre formulaire par notre expert '
    + 'et mise en concurrence de notre réseau local et national de déménageurs, '
    + '<b>vous recevrez notre sélection des 3 à 6 meilleures offres</b> pour votre '
    + 'déménagement via notre <b>comparateur de déménageurs en ligne</b>.',
  otherServiceOffer: 'Services complémentaires inclus',
  formula: {
    label: 'Formule {formula}',
    FORM_LUXE: 'Complète',
    FORM_STANDARD: 'Standard',
    FORM_ECO: 'Eco',
    FORM_TRANSPORT: 'Transport',
  },
  cancel: 'Annuler ma demande',
  cancelProjectTitle: 'Annuler ma demande',
  cancelProjectInfos: 'Si vous changez d\'avis, vous pouvez à tout moment reprendre votre dossier pour le confirmer ultérieurement via l\'email que vous avez reçu.',
  cancelStatus: {
    budget: 'L\'estimation est hors budget.',
    concurrents: 'L\'estimation est trop élevée par rapport aux devis déjà reçus.',
    estimOnly: 'Je voulais juste une estimation, pas de devis pour l\'instant.',
    tooDifficult: 'Le formulaire est trop compliqué.',
    other: 'Autre',
  },
  cancelPlaceholder: {
    other: 'Commentaires',
  },
  cancelWarning: 'Ce champ est obligatoire',
  cancelLabel: 'Je souhaite annuler ma demande pour la raison suivante :',
  cancelDescriptionLabel: 'Commentaires :',
  cancelInfos: 'Votre dossier a bien été annulé. Vous pouvez toujours le confirmer si vous le souhaitez.',
};
